import { CONFIG } from '../config';
import styles from './Hero.module.css';

export default function Hero() {
  const { hero } = CONFIG;
  return (
    <section className={styles.hero}>
      <div className={styles.heroBg} />
      <div className={styles.gridBg} />
      <div className={styles.ring} />
      <div className={`${styles.ring} ${styles.ring2}`} />
      <div className={`${styles.ring} ${styles.ring3}`} />

      <div className={styles.content}>
        <div className={styles.badge}>
          <span className={styles.badgeDot} />
          {hero.badge}
        </div>

        <h1 className={styles.title}>
          <span className={styles.gold}>{hero.titleLine1}</span>
          <br />
          <span className={styles.outline}>GLADI</span>ATOR
        </h1>

        <div className={styles.sub}>{hero.subtitle}</div>

        <p className={styles.desc}>
          Scanning trends, engaging builders, and executing{' '}
          <strong>onchain actions across Base</strong>.{' '}
          {hero.description.split('Built for')[1]
            ? 'Built for' + hero.description.split('Built for')[1]
            : hero.description}
        </p>

        <div className={styles.actions}>
          <button className={styles.btnPrimary}>{hero.ctaPrimary}</button>
          <a href="#terminal" className={styles.btnSecondary}>
            {hero.ctaSecondary}
          </a>
        </div>
      </div>

      {/* Animated core visual */}
      <div className={styles.visual}>
        <div className={styles.gladiatorCore}>
          <div className={styles.orbit}>
            <div className={styles.orbitDot} />
          </div>
          <div className={`${styles.orbit} ${styles.orbit2}`}>
            <div className={`${styles.orbitDot} ${styles.orbitDotBlue}`} />
          </div>
          <div className={styles.coreCenter}>⚔️</div>
        </div>
      </div>
    </section>
  );
}
